import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { slice1Actions } from "../store/reducer";

// Persistent "Search Mode" banner — shown on both Places and Map while there
// are unpromoted search results, so the bulk Add All / Clear actions (which
// already existed, just buried in Map's search submenu) are actually
// discoverable. See docs/usability-recommendations.md and the Search Mode
// plan for the full rationale.
const SearchResultsBanner = () => {
  const dispatch = useDispatch();
  const SearchResultsPlacesList = useSelector((state) => state.SearchResultsPlacesList);
  const FilterSearched = useSelector((state) => state.FilterSearched);

  if (!SearchResultsPlacesList || SearchResultsPlacesList.length === 0) return null;

  const onlySearch = FilterSearched === "only_search";
  const count = SearchResultsPlacesList.length;

  const addAll = () => {
    dispatch(slice1Actions.addAllResultsToGuide({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const toggleMixed = () => {
    dispatch(slice1Actions.SetFilterSearched({ value: onlySearch ? "all" : "only_search" }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const clearResults = () => {
    dispatch(slice1Actions.setSearchResultsPlacesList({ value: [] }));
    dispatch(slice1Actions.SetFilterSearched({ value: "all" }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        padding: "8px 12px",
        background: "#EAF0FF",
        borderBottom: "1px solid #C7D7FE",
        flexWrap: "wrap",
      }}
    >
      <span style={{ color: "#1D4ED8", fontSize: "14px", fontWeight: 500 }}>
        {count} search result{count === 1 ? "" : "s"}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button
          onClick={addAll}
          style={{
            border: "none",
            borderRadius: "6px",
            padding: "6px 10px",
            background: "#2563EB",
            color: "#fff",
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Add All
        </button>
        {/* A checkbox + constant label, not a button whose fill changes —
            "Add All"/"Clear" are one-shot actions, this is persistent
            state, and using the same button shape for both read as
            inconsistent (a filled button looks like "click this to do the
            thing," not "this is currently on"). */}
        <button
          onClick={toggleMixed}
          role="checkbox"
          aria-checked={onlySearch}
          title={onlySearch ? "Only search results, on — click to show all places" : "Only search results, off — click to show only search results"}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            border: "none",
            background: "transparent",
            padding: "6px 4px",
            color: "#2563EB",
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          <FontAwesomeIcon icon={onlySearch ? solid("square-check") : regular("square")} />
          Only
        </button>
        <button
          onClick={clearResults}
          style={{
            border: "1px solid #2563EB",
            borderRadius: "6px",
            padding: "6px 10px",
            background: "transparent",
            color: "#2563EB",
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default SearchResultsBanner;
